import React from 'react';

function BackToHome({ title, mar, action, width, active, loader }) {
  return (
    <>
      <button
        disabled={loader ? true : active === undefined ? false : !active}
        style={{ width: width, marginTop: mar && 0 }}
        onClick={action}
        className="RedirectBtn"
      >
        {loader ? 'Please wait ...' : title}
      </button>
    </>
  );
}

export default BackToHome;
